// Shown for the moment a page's code is downloading (see utils/lazyPage).
// Waits a beat before appearing so fast loads don't flash a spinner.
import { useEffect, useState } from 'react';

export default function PageLoading({ fullScreen = false }) {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setShow(true), 200);
    return () => clearTimeout(t);
  }, []);
  return (
    <div role="status" aria-live="polite" style={{
      minHeight: fullScreen ? '100vh' : '50vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
    }}>
      <style>{`@keyframes cst-spin { to { transform: rotate(360deg); } }
        @media (prefers-reduced-motion: reduce) { .cst-page-spinner { animation-duration: 2.4s !important; } }`}</style>
      {show && (
        <span className="cst-page-spinner" aria-hidden="true" style={{
          width: 34, height: 34, borderRadius: '50%', border: '3px solid rgba(0,0,0,0.12)', borderTopColor: '#F97316',
          animation: 'cst-spin 0.8s linear infinite', display: 'inline-block',
        }} />
      )}
      <span style={{ position: 'absolute', width: 1, height: 1, overflow: 'hidden', clip: 'rect(0,0,0,0)' }}>Loading page…</span>
    </div>
  );
}
